import { render, staticRenderFns } from "./TransferToAssetList.vue?vue&type=template&id=e4937c78&"
import script from "./TransferToAssetList.vue?vue&type=script&lang=ts&"
export * from "./TransferToAssetList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4937c78')) {
      api.createRecord('e4937c78', component.options)
    } else {
      api.reload('e4937c78', component.options)
    }
    module.hot.accept("./TransferToAssetList.vue?vue&type=template&id=e4937c78&", function () {
      api.rerender('e4937c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/transfer-to-asset/TransferToAssetList.vue"
export default component.exports